import './cardHeaderDetails.scss';

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const classNames = require('classnames');
// @components
const CardsCreditBalanceBar = require('components/cards/cardsCreditBalanceBar/cardsCreditBalanceBar');
// @constants
const { CARD_CREDIT, CARD_ECARD } = require('constants/index');
const { PAY_LATER } = require('constants/flagBasedFeatures');

class CardHeaderDetails extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render () {
        const { immCard, rightSpace, isFetching, flagBasedFeatures } = this.props;
        const cardType = immCard.get('type');
        const isActive = immCard.get('active');
        const invalidStatus = ['BLOQUEADO Y CAN', 'BLOQUEADO'];
        const shouldShowTooltip = !invalidStatus.includes(immCard.get('status'))  && immCard.get('control') && ( flagBasedFeatures && flagBasedFeatures.get(PAY_LATER));
        const isCancelled = immCard.get('cancelled');
        const cardHeaderDetailsClass = classNames('card-header-details', {
            'card-header-details--right-space': rightSpace
        });

        if ((isActive || isCancelled) && (cardType === CARD_CREDIT || cardType === CARD_ECARD)) {
            return (
                <div className={cardHeaderDetailsClass}>
                    <CardsCreditBalanceBar immCard={immCard} loading={isFetching} showTooltip={shouldShowTooltip} />
                </div>
            );
        } else {
            return <div />;
        }
    }
}

CardHeaderDetails.propTypes = {
    isFetching: PropTypes.bool,
    immCard: PropTypes.object.isRequired,
    rightSpace: PropTypes.bool,
    flagBasedFeatures: PropTypes.object
};

CardsCreditBalanceBar.DefaultProps = {
    isFetching: false
};

CardsCreditBalanceBar.DefaultProps = {
    isFetching: false
}

module.exports = CardHeaderDetails;
